export const EPISODE_STARTED = 'EPISODE_STARTED';
export const EPISODE_FINISHED = 'EPISODE_FINISHED';
export const SHOW_ACCESSED = 'SHOW_ACCESSED';
export const RESET_RECOMMENDATIONS = 'RESET_RECOMMENDATIONS';

export function episodeStarted(video) {
    return {type: EPISODE_STARTED, video};
}

export function episodeFinished(video) {
    return {type: EPISODE_FINISHED, video};
}

export function showAccessed(show) {
    return {type: SHOW_ACCESSED, show};
}

export function resetRecommendations() {
    return {type: RESET_RECOMMENDATIONS};
}
